// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_263keew","container":"_20G0LmN","title":"_2GQ5MGL","clubAvatar":"_1w1lwPe","avatar":"_1eZk6CC","gamesOuterContainer":"_2lKxqCS","gamesInnerContainer":"_16uXBL7"};